import React, { useEffect } from 'react';
import TWPaymentOptionsContainer from './PaymentOptions.container';
import TWBookNow from './BookNow.container';
import { jsx as _jsx } from "react/jsx-runtime";
export var TWSessionBookingOptions = function TWSessionBookingOptions(_ref) {
  var session = _ref.session,
      sessionAccess = _ref.sessionAccess,
      getData = _ref.getData,
      currentUser = _ref.currentUser,
      existingBooking = _ref.existingBooking;
  useEffect(function () {
    getData(session.id, session.providerService.id);
  }, [session.id, session.providerService.id]);
  var free = session.price.unitAmount === 0 && session.planIds.length === 0; // HACK ALERT:
  // Casen added this "existingBooking" check on the end as a way of short circuiting a problem
  // with our assetAccess system. Right now there is a bug where a person can purchase a one-off
  // session, and then they are granted access to all future instances of that session
  // To avoid this, I am removing entitlements for one-off sessions, and checking bookings manually
  // This is not a long-term solution

  var customerEntitled = sessionAccess && sessionAccess.grantorType || free || existingBooking;
  return /*#__PURE__*/_jsx("div", {
    children: customerEntitled ? /*#__PURE__*/_jsx(TWBookNow, {
      session: session,
      currentUser: currentUser,
      sessionAccess: sessionAccess
    }) : /*#__PURE__*/_jsx(TWPaymentOptionsContainer, {
      session: session,
      currentUser: currentUser
    })
  });
};